module.exports = __webpack_public_path__ + "static/media/truepay.2c327dc6.svg";